module.exports = __webpack_public_path__ + "files/e9d428f28045a5826a08fe6f6f61808b.png";